<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <div style="display: flex; align-items: center">
        <el-radio-group v-model="status" size="mini" @change="changeList" :disabled="loading">
          <el-radio-button label="1">在架商品</el-radio-button>
          <el-radio-button label="0">未上架商品</el-radio-button>
          <el-radio-button label="2">失效商品</el-radio-button>
          <el-radio-button label="3">虚拟商品</el-radio-button>
        </el-radio-group>
        <div>
          <el-button type="danger" size="small" @click="showDialog2" style="margin-left: 20px;">导出订单</el-button>
        </div>
      </div>
    </base-header>
    <el-main>
      <el-table
        :data="goods_list"
        height="100%"
        :cell-style="someRed"
        v-loading="loading">
        <el-table-column :label="status===3?'展示图片':'商品图片'" align="center">
          <template v-slot="scope">
            <img :src=scope.row.goods_pic alt="" style="width: 50px; height: 50px">
          </template>
        </el-table-column>
        <el-table-column v-for="item in status!==3?table_column:table_column_v"
                         :key="item.index"
                         :prop="item.prop"
                         :label="item.label"
                         :align="item.align || 'center'"
                         :width="item.width">
        </el-table-column>
        <el-table-column
          v-if="status!==3"
          prop="need_send_count"
          width="150"
          align="center">
          <template slot="header" slot-scope="scope">
            <div style="display: flex; align-items: center;">
              <span>待发货数({{sort_send_name[sort_send]}})</span>
              <el-dropdown trigger="click" style="padding: 0" @command="sortList">
                <span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">默认</el-dropdown-item>
                  <el-dropdown-item command="-1">倒序</el-dropdown-item>
                  <el-dropdown-item command="1">正序</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="动作标签" align="center" width="150px;">
          <template v-slot="scope">
            <el-tag
              type="success"
              v-if="!scope.row.showActionLabelInput && scope.row.bm_action_label"
              @click="editActionLabel(scope.row)">{{scope.row.bm_action_label}}</el-tag>
            <el-autocomplete
              v-else
              select-when-unmatched
              size="mini"
              v-model="scope.row.tempActionLabel"
              placeholder="其他按回车确认"
              @select="changeActionLabel(scope.row)"
              @change="changeActionLabel(scope.row)"
              :fetch-suggestions="getActionLabel">
            </el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="订单详情" align="center" width="80" v-if="status!==3">
          <template v-slot="scope">
            <p @click="goDetail(scope.row.good_id)">查看</p>
          </template>
        </el-table-column>
        <el-table-column :label="status===3?'编辑':'管理商品'" align="center">
          <template v-slot="scope">
            <div>
              <p @click="goEdit(scope.row)" v-show="status !== 2">编辑</p>
              <p @click="postChangeStatus(scope.row)" v-show="status < 2" style="margin-left: 5px;">{{status === 1 ? '下架' : '上架'}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="status===3" label="导出电话号码" align="center" label-class-name="red">
          <template v-slot="scope">
            <download-excel
              :fetch="() => fetchData(scope.row.good_id)"
              :fields="json_fields"
              :name="scope.row.name">
              <el-button type="danger" size="small">订单消息导出</el-button>
            </download-excel>
          </template>
        </el-table-column>
        <el-table-column v-if="status===3" label="结算" align="center">
          <template v-slot="scope">
            <p @click="openDialog(scope.row)">结算</p>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </el-footer>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :before-close="closeDialog">
      <div style="margin-bottom: 10px;">电话号码：</div>
      <input type="file" accept=".xls, .xlsx" @change="findTelephone" style="margin-bottom: 10px;" id="uploadXls">
      <div>预览：</div>
      <el-row style="padding: 10px; margin: 10px; border: black solid 1px;" v-if="telephoneList.length">
        <el-col :span="8" v-for="telephone in telephoneList" :key="telephone.index">
          {{telephone}}
        </el-col>
      </el-row>
      <div>历史记录：</div>
      <el-table :data="settleList" v-loading="settleLoading">
        <el-table-column
          v-for="item in table_column_settle"
          :key="item.index"
          :prop="item.prop"
          :label="item.label"
          :align="item.align || 'center'"
          :width="item.width">
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="postTelephoneList()" :disabled="telephoneList.length===0">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog  title="导出订单" :visible.sync="dialogVisible2" width="400px">
      <el-radio-group v-model="orderAll" @change="changeDisabled">
        <el-radio :label="1">全部时间</el-radio>
        <el-radio :label="0">筛选订单</el-radio>
      </el-radio-group>
      <div style="margin-top: 20px;">
        <span style="color: black">开始时间：</span>
        <el-date-picker
          :disabled="orderDisabled"
          v-model="startTime"
          type="datetime"
          placeholder="选择开始时间"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div style="margin-top: 20px;">
        <span style="color: black">结束时间：</span>
        <el-date-picker
          :disabled="orderDisabled"
          v-model="endTime"
          type="datetime"
          placeholder="选择结束时间"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div style="margin-top: 20px;">
        <span style="color: black">订单状态：</span>
        <el-select v-model="orderStatus" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-button style="margin-top: 20px;" type="danger" size="mini" @click="downloadXLSX">导出</el-button>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from '../../../../mixins/page'
const XLSX = require('xlsx')

export default {
  name: 'GoodList',
  mixins: [pageMixin],
  data () {
    return {
      goodsListUrl: this.getDomain() + 'bmgoods/get_goods_list', // 商品列表
      vGoodsListUrl: this.getDomain() + 'bmgoods/get_v_goods_list', // 虚拟商品列表
      vGoodsPhoneUrl: this.getDomain() + 'bmgoods/get_v_goods_phone', // 虚拟商品手机号码列表
      vGoodsPhoneCheckUrl: this.getDomain() + 'bmgoods/settle_account_vgoods', // 虚拟商品手机号码结算
      vGoodsPhoneSettleUrl: this.getDomain() + 'bmgoods/get_settle_account_list', // 虚拟商品结算历史
      changeStatusUrl: this.getDomain() + 'bmgoods/change_goods_status', // 上下架商品
      changeActionLabelUrl: this.getDomain() + 'bmgoods/set_action_label', // 修改动作标签
      getExcelUrl: this.getDomain() + 'bmorder/export_order',
      table_column: [
        {
          prop: 'name',
          label: '商品名称'
        },
        {
          prop: 'goods_code',
          label: '商品编码'
        },
        {
          prop: 'create_time',
          label: '发布日期'
        },
        {
          prop: 'goods_specification',
          label: '商品规格'
        },
        {
          prop: 'order_count',
          label: '订单总数'
        }
      ],
      table_column_v: [
        {
          prop: 'name',
          label: '活动名称'
        },
        {
          prop: 'brokerage',
          label: '活动佣金（元）'
        },
        {
          prop: 'join_count',
          label: '活动参与人数'
        }
      ],
      table_column_settle: [
        {
          prop: 'nickname',
          label: '所属团长'
        },
        {
          prop: 'member_phone',
          label: '手机号码'
        },
        {
          prop: 'create_time',
          label: '结算时间',
          width: '150'
        },
        {
          prop: 'client_id',
          label: '团长id'
        },
        {
          prop: 'brokerage',
          label: '活动佣金（元）'
        }
      ],
      json_fields: {
        '电话号码': 'number',
        '记录时间': 'createTime',
        '所属团长': 'nickname',
        '微信号': 'username'
      },
      goods_list: [],
      telephoneList: [],
      settleList: [],
      dialogVisible: false,
      dialogTitle: undefined,
      loading: true,
      settleLoading: true,
      good_id: undefined,
      status: 1,
      flag: 1,
      action_labels: [{value: '静默'}, {value: '大推'}, {value: '老货再推'}],
      showActionLabelInput: false,
      tempActionLabel: undefined,
      sort_send: 0,
      sort_send_name: {'-1': '倒序', '0': '默认', '1': '正序'},
      dialogVisible2: false,
      orderAll: 1,
      startTime: undefined,
      endTime: undefined,
      orderStatus: 3,
      orderDisabled: true,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            picker.$emit('pick', date)
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date(new Date(new Date().toLocaleDateString()))
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      options: [{
        value: 0,
        label: '未发货'
      }, {
        value: 1,
        label: '已发货'
      }, {
        value: 2,
        label: '已完成'
      }, {
        value: 3,
        label: '全部'
      }]
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        status: this.status,
        sort_send: this.sort_send
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.goods_list = res.data.content.data
        this.goods_list.forEach(item => {
          item.brokerage = item.brokerage / 100
          item.create_time = this.timeTransform(item.create_time)
          this.$set(item, 'tempActionLabel', item.bm_action_label)
          this.$set(item, 'showActionLabelInput', false)
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.status !== 3 ? this.goodsListUrl : this.vGoodsListUrl, params, handle, loadings)
    },
    getSettleList () {
      let handle = res => {
        this.settleList = res.data.content.data
        this.settleList.forEach(item => {
          item.brokerage = item.brokerage / 100
          item.create_time = this.timeTransform(item.create_time)
        })
      }
      let loadings = () => {
        this.settleLoading = false
      }
      this.__axios(this.vGoodsPhoneSettleUrl, {good_id: this.good_id}, handle, loadings)
    },
    postTelephoneList () {
      let params = {
        good_id: this.good_id,
        mobile_list: this.telephoneList
      }
      let handle = res => {
        this.telephoneList = []
        document.getElementById('uploadXls').value = ''
        this.$message.success(`上传成功，核对成功数量${res.data.content.success_count}`)
        this.dialogVisible = false
      }
      let info = '是否对当前电话号码进行结算？（以预览为准）'
      this.__confirm(info, this.__axios, [this.vGoodsPhoneCheckUrl, params, handle])
    },
    postChangeStatus (row) {
      let params = {
        good_id: row.good_id
      }
      let handle = () => {
        this.$message.success(this.status === 1 ? '下架成功' : '上架成功')
        this.getList()
      }
      let info = this.status === 1 ? `确定下架${row.name}？` : `确定上架${row.name}？`
      this.__confirm(info, this.__axios, [this.changeStatusUrl, params, handle])
    },
    goDetail (id) {
      this.$router.push({
        name: 'GoodDetail',
        query: {
          good_id: id
        }
      })
    },
    goEdit (row) {
      this.$router.push({
        name: 'GoodsEdit',
        query: {
          good_id: row.good_id
        }
      })
    },
    someRed ({row, column}) {
      if (column.property === 'need_send_count' && row.need_send_count !== 0) {
        return 'color: red; font-weight: 600; font-size: 14px;'
      }
    },
    changeList () {
      this.loading = true
      this.page = 1
      this.status = parseInt(this.status)
      this.getList()
      this.flag++
    },
    async fetchData (id) {
      let response = await this.axios.post(this.vGoodsPhoneUrl, {token: sessionStorage.token, good_id: id})
      let list = response.data.content.data
      list.forEach(item => {
        list.push({
          number: item[0],
          createTime: item[1],
          nickname: item[2],
          username: item[4]
        })
      })
      list.splice(0, list.length / 2)
      return list
    },
    findTelephone ($event) {
      this.telephoneList = []
      let file = $event.target.files[0]
      let reader = new FileReader()
      reader.onload = e => {
        let workbook = XLSX.read(e.target.result, {type: 'binary'})
        let worksheet = workbook.Sheets[workbook.SheetNames[0]]
        XLSX.utils.sheet_to_json(worksheet).forEach(item => {
          this.telephoneList.push(item['电话号码'])
        })
      }
      reader.readAsBinaryString(file)
    },
    openDialog (row) {
      this.dialogTitle = row.name
      this.dialogVisible = true
      this.good_id = row.good_id
      this.getSettleList()
    },
    closeDialog (done) {
      this.telephoneList = []
      this.good_id = undefined
      document.getElementById('uploadXls').value = ''
      done()
    },
    getActionLabel (queryString, cb) {
      cb(this.action_labels)
    },
    editActionLabel (row) {
      this.goods_list.forEach(item => {
        item.showActionLabelInput = false
      })
      row.showActionLabelInput = true
    },
    changeActionLabel (row) {
      row.showActionLabelInput = true
      let handle = () => {
        row.bm_action_label = row.tempActionLabel
        row.showActionLabelInput = false
      }
      let onCancel = () => {
        row.tempActionLabel = row.bm_action_label
        row.showActionLabelInput = false
      }
      this.__confirm('确定修改？', this.__axios, [this.changeActionLabelUrl, {good_id: row.good_id, bm_action_label: row.tempActionLabel}, handle], onCancel)
    },
    sortList (value) {
      this.sort_send = value * 1
      this.getList()
    },
    downloadXLSX () {
      let params = {}
      if (!this.orderAll) {
        if (!this.startTime || !this.endTime) {
          this.$message.warning('未选择时间')
          return
        }
        if (this.startTime > this.endTime) {
          this.$message.warning('开始时间晚于结束时间')
          return
        }
        params.start_time = Math.floor(this.startTime.getTime() / 1000)
        params.end_time = Math.floor(this.endTime.getTime() / 1000)
      }
      params.order_status = this.orderStatus === 3 ? undefined : this.orderStatus
      let handle = res => {
        window.open(res.data.content.url)
      }
      this.__axios(this.getExcelUrl, params, handle)
    },
    showDialog2 () {
      this.dialogVisible2 = true
    },
    changeDisabled (value) {
      this.orderDisabled = !!value
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  p {
    color: #3a8ee6;
    cursor: pointer;
    display: inline-block;
  }
</style>
